import "xgplayer/es/index.css";
import "xgplayer/es/plugins/play/index.css";
import "xgplayer/es/plugins/controls/index.css";
import "xgplayer/es/plugins/loading/index.css";
import "xgplayer/es/plugins/start/index.css";
import "xgplayer/es/plugins/error/index.css";
import "xgplayer/es/plugins/prompt/index.css";
import "xgplayer/es/plugins/replay/index.css";
import "xgplayer/es/plugins/volume/index.css";
import "xgplayer/es/plugins/fullscreen/index.css";
import "xgplayer/es/plugins/cssFullScreen/index.css";
import "xgplayer/es/plugins/playbackRate/index.css";
import "xgplayer/es/plugins/time/index.css";
import "xgplayer/es/plugins/progress/index.css";



// WEBPACK FOOTER //
// ./src/styles/vendor/xgplayer.js